//Core imports
import React from 'react';

//Component imports
import { Card, Col, Row, Typography } from 'antd';
import { TranslationsIcon } from '../components/Icons/TranslationsIcon';
import TranslationsForm from '../components/Forms/TranslationsForm';

//Misc imports
import { t } from 'i18next';

const TranslationsScreen = () => {
  return (
    <Card
      bodyStyle={{ padding: 0 }}
    >
      <Row className="flex-column py-4 px-4">
        <Col xs={24}>
          <Row>
            <Col xs={24}>
              <Typography.Text className="fw-600 fs-lg">
                <TranslationsIcon className="mr-2"/>   {t('Manage Translations')}
              </Typography.Text>
            </Col>
            <Col xs={24}>
              <Typography.Text className="text-muted">
                {t('Allow users to manage multilingual content, enabling the Agent to interact seamlessly in multiple languages.')}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col xs={24}>
          <Row className="pt-4">
            <Col xs={24}>
              <TranslationsForm />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default TranslationsScreen;
